import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get<T>(url: string = '', params?: any) {
    return this.http.get<T>(`${this.baseUrl}${url}${this.getQueryParams(params)}`);
  }

  getResponse<T>(url: string = '', params?: any) {
    return this.http.get<T>(`${this.baseUrl}${url}${this.getQueryParams(params)}`, { observe: 'response' });
  }

  post<T>(url: string = '', body: any, params?: any) {
    return this.http.post<T>(`${this.baseUrl}${url}${this.getQueryParams(params)}`, body);
  }

  put<T>(url: string = '', body: any, params?: any) {
    return this.http.put<T>(`${this.baseUrl}${url}${this.getQueryParams(params)}`, body);
  }

  delete<T>(url: string = '', params?: any) {
    return this.http.delete<T>(`${this.baseUrl}${url}${this.getQueryParams(params)}`);
  }

  private getQueryParams(params?: any) {
    let queryParams = '';
    if (params) {
      Object.keys(params).forEach((key, index) => {
        if (params[key] !== null) {
          queryParams += queryParams.length == 0 ? '?' : '&';
          queryParams += `${key}=${encodeURIComponent(params[key])}`;
        }
      });
    }
    return queryParams;
  }
}